import '../assets/NcMentionBubble.css';
import { generateAvatarUrl } from "@nextcloud/router";
import { checkIfDarkTheme } from "../functions/isDarkTheme/index.mjs";
function getAvatarUrl(user, options) {
  return generateAvatarUrl(user, {
    size: options?.size,
    isGuestUser: options?.isGuest,
    isDarkTheme: options?.isDarkTheme ?? checkIfDarkTheme(document.body),
    guestFallback: true,
    version: options?.version
  });
}
export {
  getAvatarUrl as g
};
//# sourceMappingURL=NcMentionBubble.vue_vue_type_style_index_0_scoped_3c4a673d_lang.mjs.map
